import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Pcontrolstruct(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Control structure Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Control structure tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like Python tutorial,Python tutorial,Python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python control structure,control structure of Python,Python control structures
,control structure in Python,control structure in Pythonscript,types of looping in Python,control structure in Python with example,Python control structures examples" />
<link rel="canonical" href="https://www.codeexampler.com/python-control-structure" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python Control structure statement</h1>

    <div className="first">
        <a href="/python-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para">This program executes according to requirements. The sequence can be changed using the control structure statement. The categories and keywords are given below:
</p>
    
<h2 className="mt-4 mh2">Conditional statement:<br/></h2>
<p className="mt-4 para">The conditional statement is many types in python:<br/>
</p>
<h3 className="mt-4 mh3">1, If-condition <br/>
2, If-else<br/>
3, If-else-if<br/>
4, Nested if<br/>
5, Switch-case
</h3>
<h2 className="mt-4 mh2">python looping (iteration)<br/></h2>
<h3 className="mt-4 mh3"> There are Three types of looping in python:<br/>
</h3>
<h4 className="mt-4 ">1, While loop<br/>
2, Do-while loop<br/>
3, For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in python:<br/></h2>
<p className="mt-4 para">python supports only three types of jumping statements in python: 
<br/></p>
<h3 className="mt-4 mh3">1, Break<br/>
2, Continue<br/>
3, Goto<br/>
</h3>
  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/python-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pcontrolstruct;